export default "images/bootstrap-logo.png";